import htmlDocx from 'html-docx-js/dist/html-docx';
import { saveAs } from 'file-saver';

// export function exportToWord(elementId, fileName = 'document.docx') {
//     const content = document.getElementById(elementId).innerHTML;
//     const blob = htmlDocx.asBlob(content);
//     saveAs(blob, fileName);
// }
/**
 * 将 DOM 元素导出为 Word
 * @param {String} eleId   要导出的 DOM id
 * @param {String} fileName 下载文件名
 */
export function exportToWord(eleId, fileName = 'document.docx') {
    const ele = document.getElementById(eleId)
    if (!ele) throw new Error('元素不存在')

    // 可选：把 <canvas>（如 ECharts）转成 <img>
    const clone = ele.cloneNode(true)
    const canvases = ele.querySelectorAll('canvas')
    const cloneCanvases = clone.querySelectorAll('canvas')

    const promises = Array.from(canvases).map((canvas, i) => {
        return new Promise(resolve => {
            const url = canvas.toDataURL('image/png')
            const img = new Image()
            img.onload = () => {
                cloneCanvases[i].parentNode.replaceChild(img, cloneCanvases[i])
                resolve()
            }
            img.src = url
        })
    })

    return Promise.all(promises).then(() => {
        const html = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office"
            xmlns:w="urn:schemas-microsoft-com:office:word">
        <head><meta charset="utf-8">${document.head.innerHTML}</head>
        <body>${clone.innerHTML}</body>
      </html>`
        const blob = htmlDocx.asBlob(html)
        saveAs(blob, fileName)
    })
}